<template>
  <v-container fluid>
    <v-alert v-if="!hasFilter" type="info" text dense>
      {{ $t('adminActionLogs.search_required') }}
    </v-alert>
    <v-data-table
      v-else
      dense
      :headers="headers"
      :items="items"
      :loading="tableLoading"
      hide-default-footer
      item-key="id"
      :no-data-text="$t('adminActionLogs.no_results')"
      class="elevation-0"
    >
      <template v-slot:item.operation="{ item }">
        <span>{{ operationLabel(item.operation) }}</span>
      </template>
      <template v-slot:item.actor="{ item }">
        <span v-if="item.actor">{{ item.actor }}</span>
        <v-chip v-else x-small color="orange lighten-4" text-color="orange darken-3">
          {{ $t('adminActionLogs.source_unknown') }}
        </v-chip>
        <v-chip
          v-if="item.actorSource === 'retool'"
          x-small
          class="ml-1"
          color="blue lighten-4"
          text-color="blue darken-3"
        >
          {{ $t('adminActionLogs.source_retool') }}
        </v-chip>
      </template>
      <template v-slot:item.createdAt="{ item }">
        <span>{{ item.createdAt | moment('MM/D/YYYY HH:mm') }}</span>
      </template>
    </v-data-table>
    <div class="text-center pt-2" v-if="hasFilter">
      <v-pagination
        @input="setValue($event)"
        :length="length"
        :value="value"
        circle
        :disabled="length < 1"
        :total-visible="7"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'AdminActionLogsTable',
  props: {
    items: { type: Array, default: () => ([]) },
    tableLoading: { type: Boolean, default: false },
    value: { type: [String, Number], default: 1 },
    length: { type: [String, Number], default: 1 },
    hasFilter: { type: Boolean, default: false },
  },
  computed: {
    headers() {
      return [
        { text: this.$t('adminActionLogs.table'), value: 'tableName', sortable: false },
        { text: 'ID', value: 'rowPk', sortable: false },
        { text: this.$t('adminActionLogs.operation'), value: 'operation', sortable: false },
        { text: this.$t('adminActionLogs.column'), value: 'columnName', sortable: false },
        { text: this.$t('adminActionLogs.old_value'), value: 'oldValue', sortable: false },
        { text: this.$t('adminActionLogs.new_value'), value: 'newValue', sortable: false },
        { text: this.$t('adminActionLogs.actor'), value: 'actor', sortable: false },
        { text: this.$t('adminActionLogs.date'), value: 'createdAt', sortable: false },
      ];
    },
  },
  methods: {
    operationLabel(operation) {
      const map = {
        INSERT: this.$t('adminActionLogs.operation_insert'),
        UPDATE: this.$t('adminActionLogs.operation_update'),
        DELETE: this.$t('adminActionLogs.operation_delete'),
      };
      return map[operation] ?? operation;
    },
    setValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
